import { render, staticRenderFns } from "./ISAMonthlyReportLicense.vue?vue&type=template&id=4060fd57&scoped=true&"
import script from "./ISAMonthlyReportLicense.vue?vue&type=script&lang=js&"
export * from "./ISAMonthlyReportLicense.vue?vue&type=script&lang=js&"
import style0 from "./ISAMonthlyReportLicense.vue?vue&type=style&index=0&id=4060fd57&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4060fd57",
  null
  
)

export default component.exports